import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearPermissions } from "../../redux/slice/permissions";
import { clearProfileInfo } from "../../redux/slice/getProfileInfo";
import { useCallback } from "react";

const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logout = useCallback((showToast = true) => {
        localStorage.removeItem("token");
        dispatch(clearPermissions());
        dispatch(clearProfileInfo());
        if (showToast) toast.success("Logout Successfully");
        navigate("/");
    }, [dispatch, navigate]);

    return logout;
};

export default useLogout;